import { dotPick } from "astrid-firestore/src/utils/dotObject";

import renderChildren from "../../../utils/renderChildren";

import TableCellPlaceholder from "./TableCellPlaceholder";

export default function TableCellValue({ data, row, index, column }) {
	// TODO: Deprecate accessor in favor of Cell
	const value = column.accessor ? column.accessor(row) : dotPick(column.id, row);

	if ((column.loading === true && !value) || (typeof column.loading === "function" && column.loading(row))) {
		return <TableCellPlaceholder />;
	}

	const cell = column.Cell ? renderChildren(column.Cell, { data, row, index, value, column }) : value;

	return cell;
}
